import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { FaGift } from "react-icons/fa";
import { getUserProfile1 } from "../../services/User";
import { api } from "../../services/api"; // instance đã gắn token
import { isBirthdayTodayLocal } from "../../utils/date";
const ENDPOINT_HISTORY = "/BirthdaySpin/history";
const SESSION_KEY = "birthdaySpinDone";

const BirthdaySpinFloatingButton = () => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const mounted = useRef(true);

  useEffect(() => {
    mounted.current = true;

    const fetchProfileAndSpin = async () => {
      try {
        // 0) nếu đang ở trang vòng quay -> ẩn
        if (pathname === "/birthday-spin") return;

        // 1) nếu session đã quay rồi -> ẩn
        if (sessionStorage.getItem(SESSION_KEY) === "1") {
          setShow(false);
          return;
        }

        // 2) lấy profile
        const profile = await getUserProfile1();
        if (!profile?.dateOfBirth) return;

        // 3) đúng ngày sinh?
        const isBirthday = isBirthdayTodayLocal(profile.dateOfBirth);
        if (!isBirthday) return;

        // 4) kiểm tra history (chỉ khi đúng ngày)
        const his = await api.get(ENDPOINT_HISTORY).catch((e) => e.response);
        if (his?.status === 404 || his?.status === 204 || !his?.data?.history) {
          // đã quay rồi -> ẩn và đánh dấu session
          if (mounted.current) setShow(true);
        } else {
          // đã quay
          sessionStorage.setItem(SESSION_KEY, "1");
          if (mounted.current) setShow(false);
        }
      } catch {
        if (mounted.current) setShow(false);
      } finally {
        if (mounted.current) setLoading(false);
      }
    };

    fetchProfileAndSpin();
    return () => {
      mounted.current = false;
    };
  }, [pathname]);

  if (!show || loading) return null;

  return (
    <button
      type="button"
      className="birthday-spin-float-btn"
      aria-label="Nhận ưu đãi sinh nhật"
      title="Nhấn để nhận ưu đãi sinh nhật!"
      onClick={() => navigate("/birthday-spin")}
      style={{
        position: "fixed",
        left: 26,
        bottom: 38,
        zIndex: 9999,
        background: "linear-gradient(90deg, #d18b0f 40%, #ffbe4b 100%)",
        color: "#fff",
        borderRadius: "50%",
        boxShadow: "0 4px 24px #fff2cc88",
        width: 60,
        height: 60,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
        fontSize: 32,
        border: "2.5px solid #fff7e1",
        transition: "transform 0.15s",
      }}
    >
      <FaGift aria-hidden="true" />
      <style>{`
        .birthday-spin-float-btn { animation: shake 2.2s infinite; }
        @keyframes shake {
          0%, 100% { transform: translateX(0); }
          10%, 30%, 50%, 70% { transform: translateX(-4px); }
          20%, 40%, 60%, 80% { transform: translateX(4px); }
        }
        .birthday-spin-float-btn:hover { transform: scale(1.09); }
        @media (prefers-reduced-motion: reduce) {
          .birthday-spin-float-btn { animation: none; }
        }
      `}</style>
    </button>
  );
};

export default BirthdaySpinFloatingButton;
